import React from 'react';
import PropTypes from 'prop-types';

export default class FetcherButton extends React.PureComponent {
  render() {
    const {
      isLoading,
      previousPage,
      totalPages,
      getItems,
      text,
    } = this.props;

    return (
      <button
        type="button"
        disabled={isLoading || previousPage >= totalPages}
        className={`FetcherButton ${
          isLoading ? 'FetcherButton--loading' : ''
        } ${
          previousPage >= totalPages ? 'FetcherButton--hidden' : ''
        }`}
        onClick={() => getItems(previousPage + 1)}
      >
        {isLoading ? (
          <span className="FetcherButton__text--loading">Loading</span>
        ) : (
          <p className="FetcherButton__text">{text}</p>
        )}
      </button>
    );
  }
}

FetcherButton.propTypes = {
  previousPage: PropTypes.number,
  totalPages: PropTypes.number,
  isLoading: PropTypes.bool,
  getItems: PropTypes.func.isRequired,
  text: PropTypes.string,
};

FetcherButton.defaultProps = {
  previousPage: 0,
  totalPages: 1,
  isLoading: false,
  text: 'See more',
};
